import { ThemeProvider } from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';
import axios from 'axios';
import MaterialTable from 'material-table';
import { Component } from "react";
import { Button, Card, Form, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { Redirect } from 'react-router-dom';
import { hasPermission } from "../utils/usePermission";
import { validateForExitEmployee } from "../utils/validation";
import { DateTimeFormat } from "./DateFormat/DateTimeFormat";
import DeleteModal from './DeleteModal';
import CommonLoader from "./loaderComponent/CommonLoader";
import CommonToast from "./Toaster/CommonToast";


export default class EmployeeList extends Component {

  constructor(props) {
    super(props)

    this.state = {
      users: [],
      selectedUser: null,
      viewRedirect: false,
      editRedirect: false,
      deleteModal: false,
      loading: true,
      showExitModal: false,
      selectedEmployee: null,
      exitDate: '',
      exitReason: '',
      errors: {},
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: '',
    }
  }
  fetchList = () => {
    axios({
      method: 'get',
      url: '/users/nullend',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => {
        this.setState({
          users: res.data,
          loading: false
        })
      })
      .catch(err => {
        console.log(err)
      })
  }
  componentDidMount() {
    this.fetchList()
  }

  onView = (user) => {
    return (event) => {
      event.preventDefault()
      this.setState({ selectedUser: user, viewRedirect: true })
    }
  }

  onEdit = (user) => {
    return (event) => {
      event.preventDefault()
      this.setState({ selectedUser: user, editRedirect: true })
    }
  }

  onDelete = user => {
    return event => {
      event.preventDefault()
      this.setState({ selectedUser: user, deleteModal: true })
    }
  }


  handleMoveAddEmployee = () => {
    this.props.history.push('/employee-add')
  }

  handleImageUpload = (type, rowData) => {
    console.log(`Uploading ${type} for`, rowData);
    // Implement file upload logic here
  };
  handleExitEmp = (data) => {
    this.setState({
      showExitModal: true,
      selectedEmployee: data,
      exitDate: '',
      exitReason: ''
    });
  }

  handleFieldChange = (fieldName, value) => {
    this.setState(
      { [fieldName]: value },
      () => {
        const { exitDate, exitReason, errors } = this.state;
        let updatedErrors = { ...errors };

        // Validate only the field that was changed
        switch (fieldName) {
          case 'exitDate':
            updatedErrors.exitDate = validateForExitEmployee('exitDate', value);
            break;
          case 'exitReason':
            updatedErrors.exitReason = validateForExitEmployee('exitReason', value);
            break;
          default:
            break;
        }

        this.setState({ errors: updatedErrors });
      }
    );
  };

  // handleFieldChange = (fieldName, value) => {
  //   this.setState(
  //     { [fieldName]: value },
  //     () => {
  //       const { exitDate, exitReason } = this.state;
  //       const errors = validateForExitEmployee(exitDate, exitReason);
  //       this.setState({ errors });
  //     }
  //   );
  // };

  handleSubmitExit = async () => {
    // debugger;
    const { selectedEmployee, exitDate, exitReason } = this.state;
    const token = localStorage.getItem("token");
    const errors = validateForExitEmployee(
      exitDate, exitReason
    );

    const headers = { Authorization: `Bearer ${token}` };
    const ExitEmpPayloadData = {
      endDate: exitDate,
      remark: exitReason

    }
    if (Object.keys(errors).length > 0) {
      this.setState({ errors, loading: false });
      return;
    }

    try {
      await axios.put(`/users/updateEndDate/${selectedEmployee?.id}`, ExitEmpPayloadData, { headers });
      this.setState({
        toastMessage: "Exist employee successfully!",
        toastVariant: 'success',
        color: 'green',
        showToast: true,
      });
      setTimeout(() => {
        this.setState({
          loading: false, showToast: false, showExitModal: false,
          selectedEmployee: null,
          exitDate: '',
          exitReason: ''
        });
        this.fetchList()
      }, 900);

    } catch (error) {
      console.log("error", error);
      let errorMessage = "Failed to exist employee.";
      if (error.response) {
        if (error.response.status === 404) {
          errorMessage = error.response.data.err;
        } else if (error.response.status === 403) {
          errorMessage = "Access Denied! Admin privileges required.";
        }
      }
      this.setState({
        hasError: true,
        errMsg: errorMessage,
        toastMessage: errorMessage,
        toastVariant: 'danger',
        color: 'red',
        showToast: true,
      });
      setTimeout(() => {
        this.setState({ loading: false, showToast: false, showExitModal: false });
      }, 900);
    }

  };

  render() {
    const baseStyle = {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      fontSize: '0.875rem',
      padding: '4px 10px',
      borderRadius: '20px',
    };
    let closeDeleteModel = () => this.setState({ deleteModal: false })

    const theme = createTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: '6px 6px 6px 6px'
          }
        }
      }
    })


    return (

      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />

        <CommonLoader isLoading={this.state.loading}>
          <div className="container-fluid pt-4">
            {this.state.viewRedirect ? (<Redirect to={{ pathname: '/employee-view', state: { selectedUser: this.state.selectedUser } }}></Redirect>) : (<></>)}
            {this.state.editRedirect ? (<Redirect to={{ pathname: '/employee-edit', state: { selectedUser: this.state.selectedUser } }}></Redirect>) : (<></>)}
            {this.state.deleteModal ? (
              <DeleteModal show={true} onHide={closeDeleteModel} data={this.state.selectedUser} />
            ) : (<></>)}
            <div className='d-flex search-btn-gap'>
              {
                hasPermission('M7S2B1') && (
                  <div className='add-role'>
                    <Button onClick={this.handleMoveAddEmployee} variant="primary" className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button"> <i className="fa fa-plus-circle"></i> Add Employee</Button>
                  </div>
                )
              }
            </div>
            <div className="col-sm-12">
              <Card>
                <Card.Header style={{ backgroundColor: "#515e73", color: "white" }}>
                  <div className="panel-title">
                    <strong>Employee List</strong>
                  </div>
                </Card.Header>
                <Card.Body>
                  <ThemeProvider theme={theme}>
                    <MaterialTable
                      columns={[
                        { title: 'EMP ID', field: 'id' },
                        {
                          title: 'Full Name', field: 'fullName',
                          cellStyle: { minWidth: 200 },
                          headerStyle: { minWidth: 200 }
                        },
                        {
                          title: 'Department', field: 'department.departmentName',
                          cellStyle: { minWidth: 150 },
                          headerStyle: { minWidth: 150 }
                        },

                        {
                          title: "Job Title",
                          field: "jobs",
                          cellStyle: { minWidth: 250 },
                          headerStyle: { minWidth: 250 },
                          render: (rowData) => {
                            // if (!rowData.jobs || rowData.jobs.length === 0) return "No Job Assigned";
                            // const today = new Date();
                            // today.setHours(0, 0, 0, 0);

                            // const activeJobs = rowData.jobs.filter(job => {
                            //   const start = new Date(job.startDate);
                            //   const end = new Date(job.endDate);
                            //   start.setHours(0, 0, 0, 0);
                            //   end.setHours(23, 59, 59, 999);
                            //   return start <= today && end >= today;
                            // });
                            // console.log("Jobs:", rowData);
                            // console.log("Active Jobs:", activeJobs);
                            // return activeJobs.length ? activeJobs.map(job => job.jobTitle).join(", ") : "No Active Jobs";
                            return rowData?.jobTitle
                          }
                        },

                        // {
                        //   title: "Job Title",
                        //   field: "jobs",
                        //   render: rowData => (
                        //     rowData.jobs.map((job, index) => {
                        //       return job.jobTitle
                        //     })
                        //   )
                        // },
                        {
                          title: 'Mobile', field: 'user_personal_info.mobile',
                          cellStyle: { minWidth: 120 },
                          headerStyle: { minWidth: 120 }
                        },

                        {
                          title: 'Job Start Date',
                          field: 'jobs',
                          cellStyle: { width: 250, minWidth: 250 },
                          headerStyle: { width: 250, minWidth: 250 },
                          render: rowData => rowData.jobs.map((job) => DateTimeFormat(job.startDate)).join(" ")
                        },
                        // {
                        //   title: 'Jon End Date',
                        //   field: 'jobs',
                        //   render: rowData => (
                        //     rowData.jobs.map((job, index) => {
                        //       return DateTimeFormat(job.endDate)
                        //     })
                        //   )
                        // },
                        // {
                        //   title: 'Status',
                        //   field: 'active',
                        //   width: '120',
                        //   render: rowData => (
                        //     rowData.active ? (
                        //       <Badge pill variant="success">Active</Badge>
                        //     ) : (
                        //       <Badge pill variant="danger">Inactive</Badge>
                        //     )
                        //   )
                        // },
                        // {
                        {
                          title: 'OT Status',
                          field: 'otStatus',
                          render: rowData => {
                            const otStatus = rowData?.user_financial_info?.otStatus;

                            const status = otStatus?.toString().toLowerCase();

                            const getStatusStyles = (status) => {
                              switch (status) {
                                case 'yes':
                                  return {
                                    backgroundColor: "#E6F4EA",
                                    color: "#216e39",
                                    border: "1px solid #B6E2C5",
                                    icon: <FaCheckCircle />
                                  };
                                case 'no':
                                  return {
                                    backgroundColor: "#FBEAEA",
                                    color: "#A94442",
                                    border: "1px solid #F1B5B5",
                                    icon: <FaTimesCircle />
                                  };
                                default:
                                  return {
                                    backgroundColor: "#E2E3E5",
                                    color: "#6C757D",
                                    border: "1px solid #D3D6D8",
                                    icon: null
                                  };
                              }
                            };

                            const { backgroundColor, color, border, icon } = getStatusStyles(status);

                            const baseStyle = {
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "6px",
                              padding: "4px 12px",
                              borderRadius: "20px",
                              fontSize: "0.75rem",
                              fontWeight: 600,
                              textTransform: "uppercase",
                              backgroundColor,
                              color,
                              border,
                              minWidth: "60px",
                              textAlign: "center",
                            };

                            const label =
                              otStatus?.toLowerCase() === 'yes'
                                ? 'Yes'
                                : otStatus?.toLowerCase() === 'no'
                                  ? 'No'
                                  : 'N/A';

                            return (
                              <span style={baseStyle}>
                                {icon} {label}
                              </span>
                            );
                          }
                          // return rowData?.user_financial_info ?
                          //   rowData?.user_financial_info?.otStatus === 'Yes' ? (
                          //     <Badge pill variant="success" className="text-color">Yes</Badge>
                          //   ) : (
                          //     <Badge pill variant="warning" className="text-color">No</Badge>
                          //   ) : null

                        },

                        {
                          title: 'ESIC Status',
                          field: 'esicStatus',
                          render: (rowData) => {
                            const esicStatus = rowData?.user_financial_info?.esicStatus?.toLowerCase();

                            const getStatusStyles = (status) => {
                              switch (status) {
                                case 'yes':
                                  return {
                                    backgroundColor: "#E6F4EA",
                                    color: "#216e39",
                                    border: "1px solid #B6E2C5",
                                    icon: <FaCheckCircle />
                                  };
                                case 'no':
                                  return {
                                    backgroundColor: "#FBEAEA",
                                    color: "#A94442",
                                    border: "1px solid #F1B5B5",
                                    icon: <FaTimesCircle />
                                  };
                                default:
                                  return {
                                    backgroundColor: "#E2E3E5",
                                    color: "#6C757D",
                                    border: "1px solid #D3D6D8",
                                    icon: null
                                  };
                              }
                            };

                            const { backgroundColor, color, border, icon } = getStatusStyles(esicStatus);

                            const baseStyle = {
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "6px",
                              padding: "4px 12px",
                              borderRadius: "20px",
                              fontSize: "0.75rem",
                              fontWeight: 600,
                              textTransform: "uppercase",
                              backgroundColor,
                              color,
                              border,
                              minWidth: "60px",
                              textAlign: "center",
                            };

                            const label = esicStatus === 'yes' ? 'Yes' : esicStatus === 'no' ? 'No' : 'N/A';

                            return (
                              <span style={baseStyle}>
                                {icon} {label}
                              </span>
                            );
                          }

                          // return rowData?.user_financial_info ? rowData?.user_financial_info?.esicStatus === 'Yes' ? (
                          //   <Badge pill variant="outline-success">Yes</Badge>
                          // ) : (
                          //   <Badge pill variant="outline-danger">No</Badge>
                          // ) : null
                          // return rowData?.user_financial_info?.esicStatus

                        },
                        {
                          title: 'OT (Hours)',
                          field: 'OtWorkingHours',
                          render: rowData => {
                            return rowData?.user_financial_info ? (
                              <div className="round">
                                {rowData.user_financial_info.OtWorkingHours}
                              </div>
                            ) : null;

                          }
                        },
                        {
                          title: 'Login(Yes/No)',
                          field: 'active',
                          cellStyle: { width: 120, minWidth: 120 },
                          headerStyle: { width: 120, minWidth: 120 },
                          render: rowData => {
                            const loginStatus = rowData.active;
                            const baseStyle = {
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "6px",
                              padding: "4px 12px",
                              borderRadius: "20px",
                              fontSize: "0.75rem",
                              fontWeight: 600,
                              textTransform: "uppercase",
                              backgroundColor: loginStatus ? "#E6F4EA" : "#FBEAEA",
                              color: loginStatus ? "#216e39" : "#A94442",
                              border: `1px solid ${loginStatus ? "#B6E2C5" : "#F1B5B5"}`,
                              minWidth: "60px",
                              textAlign: "center",
                            };

                            if (loginStatus) {
                              return (
                                <span style={{ ...baseStyle }}>
                                  <FaCheckCircle /> Yes
                                </span>
                              );
                            } else {
                              return (
                                <span style={{ ...baseStyle }}>
                                  <FaTimesCircle /> No
                                </span>
                              );
                            }
                          }
                          // render: rowData => (
                          //   rowData.active ? (
                          //     <Badge pill variant="outline-success">Yes</Badge>
                          //   ) : (
                          //     <Badge pill variant="outline-danger">No</Badge>
                          //   )
                          // )
                        },

                        // {
                        //   title: 'View',
                        //   render: rowData => (
                        //     hasPermission('M7S2B2') ? (
                        //       <Form>
                        //         <OverlayTrigger
                        //           placement="top"
                        //           overlay={<Tooltip id={`tooltip-edit-${rowData.id}`}>View Employee Details</Tooltip>}
                        //         >
                        //           <Button size="sm" variant="outline-info" onClick={this.onView(rowData)}><i className="far fa-eye"></i></Button>
                        //         </OverlayTrigger>
                        //       </Form>
                        //     ) : null
                        //   )
                        // },

                        {
                          title: 'Action',
                          render: rowData => (
                            <>
                              {rowData.id !== JSON.parse(localStorage.getItem('user')).id ? (
                                <>
                                  {hasPermission('M7S2B2') && (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={<Tooltip id={`tooltip-edit-${rowData.id}`}>View Employee Details</Tooltip>}
                                    >
                                      <Button size="sm" variant="outline-info" className="mr-2 info" onClick={this.onView(rowData)}><i className="far fa-eye"></i></Button>
                                    </OverlayTrigger>
                                  )}
                                  {hasPermission('M7S2B3') && (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={<Tooltip id={`tooltip-edit-${rowData.id}`}>Edit Employee Details</Tooltip>}
                                    >
                                      <Button size="sm" variant="outline-info" className="mr-2 info" onClick={this.onEdit(rowData)}><i className="far fa-edit"></i></Button>
                                    </OverlayTrigger>
                                  )}
                                  {hasPermission('M7S2B4') && (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={<Tooltip id={`tooltip-edit-${rowData.id}`}>Assign Project to Employee</Tooltip>}
                                    >
                                      <Button size="sm" variant="outline-info" className="mr-2 info" onClick={() => this.props.history.push("/assign-project", { userId: rowData.id, userName: rowData.name })}><i className=" fas fa-project-diagram"></i></Button>
                                    </OverlayTrigger>
                                  )}
                                  {hasPermission('M7S2B6') && (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={<Tooltip id={`tooltip-edit-${rowData.id}`}>Exit Employee</Tooltip>}
                                    >
                                      <Button size="sm" variant="outline-info" className="mr-2 info" onClick={() => this.handleExitEmp(rowData)}>  <i className="fa fa-user-times"></i></Button>
                                    </OverlayTrigger>
                                  )}
                                </>
                              ) : (<></>)}

                              {hasPermission('M7S2B5') && (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip id={`tooltip-edit-${rowData.id}`}>Upload Employee Doc</Tooltip>}
                                >
                                  <Button size="sm" variant="outline-info" className="mr-2 info" onClick={() => this.props.history.push("/upload", { userId: rowData.id, userName: rowData.name })}><i className="fa fa-upload"></i></Button>
                                </OverlayTrigger>
                              )}

                              {/* {rowData.id !== JSON.parse(localStorage.getItem('user')).id ? (
                              <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip id={`tooltip-edit-${rowData.id}`}>Delete Employee </Tooltip>}
                              >
                                <Button size="sm" variant="danger" className="ml-1" onClick={this.onDelete(rowData)}><i className="fas fa-trash"></i></Button>
                              </OverlayTrigger>
                            ) : (<></>)} */}
                            </>
                          ),
                          cellStyle: { width: '250px', minWidth: '250px', textAlign: 'center' }, // Adjust width as needed
                          headerStyle: { width: '250px', minWidth: '250px', textAlign: 'center' }
                        }
                      ]}
                      data={this.state.users}
                      options={{
                        rowStyle: (rowData, index) => {
                          if (index % 2) {
                            return { backgroundColor: '#f2f2f2' }
                          }
                        },
                        pageSize: 10,
                        pageSizeOptions: [10, 20, 30, 50, 75, 100]
                      }}
                      title="Employees"
                    />
                  </ThemeProvider>
                </Card.Body>
              </Card>
            </div>
          </div>
          <Modal show={this.state.showExitModal} onHide={() => this.setState({ showExitModal: false })}>
            <Modal.Header closeButton>
              <Modal.Title>Exit Employee</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Group>
                <Form.Label className='required'>Exit Date</Form.Label>
                <Form.Control
                  type="date"
                  value={this.state.exitDate}
                  onChange={(e) => this.handleFieldChange("exitDate", e.target.value)}
                />
              </Form.Group>
              <span className="login-error">
                {typeof this.state.errors.exitDate === 'string' && (
                  <small className="text-danger">{this.state.errors.exitDate}</small>
                )}
                {/* {this.state.errors.exitDate && <small className="text-danger">{this.state.errors.exitDate}</small>} */}
              </span>
              <Form.Group>
                <Form.Label className='required'>Reason</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={this.state.exitReason}
                  placeholder="Enter exit reason"
                  onChange={(e) => this.handleFieldChange("exitReason", e.target.value)}
                />
              </Form.Group>
              <span className="login-error">
                {typeof this.state.errors.exitReason === 'string' && <small className="text-danger">{this.state.errors.exitReason}</small>}
              </span>
            </Modal.Body>
            <Modal.Footer>
              <Button variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary" onClick={this.handleSubmitExit}>
                Submit
              </Button>
              <Button variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel" onClick={() => this.setState({ showExitModal: false })}>
                Cancel
              </Button>

            </Modal.Footer>
          </Modal>
        </CommonLoader>
      </>
    );
  }
}
